import React, { Component } from 'react';
import PropTypes from 'prop-types';
import now from 'lodash/now';

import Banner from 'zignal-landscape/lib/Banner';
import themeable from 'zignal-landscape/lib/themeable';

class BotBanner extends Component {
  constructor(props){
    super(props);
    this.state = {};
    this.handleCountdown = this.handleCountdown.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps){
    if (nextProps.bannerMessage && this.props.bannerMessage !== nextProps.bannerMessage){
      const countdownTimestamp = now();
      this.setState({countdownTimestamp});
      this.handleCountdown(countdownTimestamp);
    }
  }

  handleCountdown(timestamp){
    setTimeout(() => {
      if (this.state.countdownTimestamp === timestamp){
        this.props.clearBannerMessage();
      }
    }, 10000);
  }

  render(){
    const { styles, bannerMessage, clearBannerMessage } = this.props;
    if (!bannerMessage){
      return null;
    }
    const { type, title, contentMsg } = bannerMessage;

    return (
      <div className={styles.BotBanner}>
        <Banner
          bannerStyle="inline"
          bannerType={type}
          title={title}
          onClick={clearBannerMessage}
        >
          {contentMsg}
        </Banner>
      </div>
    );
  }
}

BotBanner.defaultProps = {
  styles: {}
};

BotBanner.propTypes = {
  styles: PropTypes.object,
  bannerMessage: PropTypes.object,
  fetchErrorMessage: PropTypes.string,
  clearBannerMessage: PropTypes.func
};

export default themeable(BotBanner);
